import { jsx as _jsx } from "react/jsx-runtime";
import { PushpinOutlined } from "@ant-design/icons";
import { Popover, Switch } from "antd";
import { observer } from "mobx-react-lite";
import { useTranslation } from "../../../../others/i18n.js";
import { useStores } from "../../../../store/root.js";
const StickyModeSwitch = observer(()=>{
    const { t } = useTranslation();
    const { rcbUserSettingsStore } = useStores();
    const { settings: { translationSettings } } = rcbUserSettingsStore;
    return /*#__PURE__*/ _jsx(Popover, {
        title: t("Sticky Mode"),
        content: t("If enabled, the translation menu is pinned at the top, even if you scroll down."),
        placement: "left",
        children: /*#__PURE__*/ _jsx(Switch, {
            checked: translationSettings.isStickyMode,
            checkedChildren: /*#__PURE__*/ _jsx(PushpinOutlined, {}),
            unCheckedChildren: /*#__PURE__*/ _jsx(PushpinOutlined, {}),
            onChange: (isSticky)=>rcbUserSettingsStore.updateTranslationSettings({
                    isStickyMode: isSticky
                }),
            size: "small"
        })
    });
});
export { StickyModeSwitch };
